"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CccisdFieldWrapper = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function CccisdFieldWrapper() {
    _classCallCheck(this, CccisdFieldWrapper);
    return _callSuper(this, CccisdFieldWrapper, arguments);
  }
  _inherits(CccisdFieldWrapper, _React$Component);
  return _createClass(CccisdFieldWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        field = _this$props.field,
        form = _this$props.form,
        label = _this$props.label,
        description = _this$props.description,
        showErrorImmediately = _this$props.showErrorImmediately,
        wrapperClassName = _this$props.wrapperClassName;

      // use `_get` because field.name might have "." and `errors` is not flattened
      var error = (0, _get2["default"])(form.errors, field.name);
      var showError = !!(error && (form.submitCount > 0 || showErrorImmediately));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(showError && "is-invalid ".concat(_style["default"].hasError))
      }, label && /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label",
        htmlFor: field.name
      }, label), description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].description
      }, description), this.props.children), showError && /*#__PURE__*/_react["default"].createElement("div", {
        className: "invalid-feedback"
      }, error));
    }
  }]);
}(_react["default"].Component);
_defineProperty(CccisdFieldWrapper, "propTypes", {
  field: _propTypes["default"].object,
  label: _propTypes["default"].node,
  description: _propTypes["default"].node,
  form: _propTypes["default"].object,
  showErrorImmediately: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  wrapperClassName: _propTypes["default"].string
});
_defineProperty(CccisdFieldWrapper, "defaultProps", {
  wrapperClassName: 'mb-3'
});